// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { GeneralKind } from "../../../define/GeneralKind";
import { MessageEventKind } from "../../../define/MessageEventKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import UserDataManage from "../../model/UserDataManage";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MatchMiaiBuyEquipLayer extends BasePopUpLayer {


    @property({ type: cc.Node, displayName:'' })
	nodeLayout: cc.Node = null;

    @property({ type: cc.Node, displayName:'' })
	nodeEquipItem: cc.Node = null;

    // LIFE-CYCLE CALLBACKS:

    private csvInfos: any = null;
    // onLoad () {}

    start () {
        this.nodeEquipItem.active = false;
        this.initLayer();
    }

    initLayer() {
        let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
        let matchMiaiData = matchMiaiDataManage.matchMiaiData;
        let csvInfos = this.csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.MATCH_MIAI);
        let title = csvInfos.title;
        for (let i in csvInfos) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }

            let bOwn = matchMiaiData.ownEquipList.includes(i);
            let info = csvInfos[i];

            let special_type = info[title.special_type];
            if (utilsModel.isValidNumberValue(special_type)) {
                continue;
            }

            if (info[title.default_own] == GeneralKind.EnableState.ENABLED) {
                continue;
            }

            let nodeItem = cc.instantiate(this.nodeEquipItem);
            nodeItem.active = true;
            this.nodeLayout.addChild(nodeItem);
            
            let btnItem = nodeItem.getChildByName('btnBuy');
            let nodeBtn = btnItem.getComponent(cc.Button);
            nodeBtn.clickEvents[0].customEventData = i;

            let nodeLayout = btnItem.getChildByName('nodeLayout');
            let sprVideo = nodeLayout.getChildByName('sprVideo');
            let sprGold = nodeLayout.getChildByName('sprGold');
            let Label = nodeLayout.getChildByName('Label').getComponent(cc.Label);

            if (!bOwn) {
                let gold_price = info[title.gold_price];
                let ad_price = info[title.ad_price];

                if (utilsModel.isValidNumberValue(gold_price)) {
                    sprVideo.active = false;
                    Label.string = data_control.getNumberFormat(Number(gold_price));
                } else if (utilsModel.isValidNumberValue(ad_price)) {
                    sprGold.active = false;
                    
                    let idx = matchMiaiData.adEquipCount.indexOf(i);
                    let curCount = 0;
                    if (idx != -1) {
                        curCount = Number(matchMiaiData.adEquipCount[idx+1]);
                    }
                    Label.string = '购买' + `(${curCount}/${ad_price})`;
                }
                
            } else {
                sprVideo.active = false;
                sprGold.active = false;
                Label.string = '已拥有';
                nodeBtn.interactable = false;
            }

            let label = nodeItem.getChildByName('labelName').getComponent(cc.Label);
            label.string = info[title.name];

            let sprEquip = nodeItem.getChildByName('sprEquip').getComponent(cc.Sprite);
            sprEquip.node.active = false;
            // 枪
            let equipPath = 'res/equip/'  + info[title.icon];
            getOneBundleByInstant(BUNDLE_SMALL_NAME.matchMiaiBundle).load(equipPath,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
                if(err){
                    console.error(err,"showEuqipUI");
                    return;
                }
                sprEquip.node.active = true;
                sprEquip.spriteFrame = spr;
            });
        }
    }

    onClickBuy(event: cc.Event.EventTouch, data) {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let id = data;
        let info = this.csvInfos[id];
        let title = this.csvInfos.title;
        let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
        let matchMiaiData = matchMiaiDataManage.matchMiaiData;

        let targetNode = event.target;

        let gold_price = info[title.gold_price];
        let ad_price = info[title.ad_price];

        if (utilsModel.isValidNumberValue(gold_price)) {
            let price = Number(gold_price);
            if ( O1HD.getServices().userSrv.getCoins() < price) {
                O1HD.getModules().uiControlModule.showMessageBox("金额不足",this.node);
                NormalGameManager._instance.openBankPage();
                return;
            }
            O1HD.getServices().userSrv.setCoins( -price, true);
            matchMiaiData.ownEquipList.push(id);
            matchMiaiData.curUseEquip = id;
            matchMiaiData.saveLocalData();
            this.setButtonState(targetNode);
        } else if (utilsModel.isValidNumberValue(ad_price)) {
            let idx = matchMiaiData.adEquipCount.indexOf(id);
            let curCount = 0;
            if (idx != -1) {
                curCount = Number(matchMiaiData.adEquipCount[idx+1]);
            } else {
                idx = matchMiaiData.adEquipCount.length;
                matchMiaiData.adEquipCount.push(id, curCount + '');
            }
            if (curCount < ad_price) {
                utilsModel.loadAndShowVideoAdTrans(()=>{
                    curCount++;
                    if (curCount >= ad_price) {
                        matchMiaiData.curUseEquip = id;
                        matchMiaiData.adEquipCount.splice(idx, 2);
                        matchMiaiData.ownEquipList.push(id);
                        this.setButtonState(targetNode);
                    } else {
                        matchMiaiData.adEquipCount[idx+1] = curCount + '';
                        // 刷新
                        let nodeLayout = targetNode.getChildByName('nodeLayout');
                        let Label = nodeLayout.getChildByName('Label').getComponent(cc.Label);
                        Label.string = '购买' + `(${curCount}/${ad_price})`;
                    }
                    matchMiaiData.saveLocalData();
                },()=>{
        
                },null,"观看广告获得招亲装备");
            }
        }

    }

    setButtonState(btn: cc.Node) {

        let button = btn.getComponent(cc.Button);
        button.interactable = false;
        let nodeLayout = btn.getChildByName('nodeLayout');

        let sprVideo = nodeLayout.getChildByName('sprVideo');
        let sprGold = nodeLayout.getChildByName('sprGold');
        let Label = nodeLayout.getChildByName('Label').getComponent(cc.Label);
        sprVideo.active = false;
        sprGold.active = false;
        Label.string = '已拥有';

        O1HD.emit(MessageEventKind.EventName.MATCH_MIAI_SWITCH_EQUIP);
    }

    onClickClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu");

        this.destroyNode();
    }


    // update (dt) {}
}
